/**
 * Image Compressor - /image category page
 * Accepts: JPG, PNG, WebP, AVIF
 */
import { createApp } from 'vue';
import ImageCompressor from '@/Components/ImageCompressor.vue';
import '@styles/app.css';

createApp(ImageCompressor).mount('#image-compressor');
